import React from 'react';
import { Col, Typography } from 'antd';
import { ActiveIcon, LikeIcon, LogInIcon, SignUpIcon } from '../Icon';
import moment from 'moment';

const { Text } = Typography;

const User = ({usersDetailsData}: any) => (
  <>
    <h3 className="user-activity-title">Activity</h3>
    <div className="user-activity">
      <Col span={12} style={{ display: 'flex' }}>
        <ActiveIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Active subscriptions</Text>
          <Text>{usersDetailsData?.active_subscriptions}</Text>
        </div>
      </Col>
      <Col span={12} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Liked</Text>
          <Text>{usersDetailsData?.likes_count}</Text>
        </div>
      </Col>
    </div>
    <h3 className="user-activity-title">Log in information</h3>
    <div className="user-info">
      <Col span={12} style={{ display: 'flex' }}>
        <SignUpIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Sign up</Text>
          <Text>{moment(usersDetailsData?.created_at).format('ddd MMMM Do YYYY, h:mm:ss')}</Text>
        </div>
      </Col>
      <Col span={12} style={{ display: 'flex' }}>
        <LogInIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Last log in</Text>
          <Text>{moment(usersDetailsData?.last_active).format('ddd MMMM Do YYYY, h:mm:ss')}</Text>
        </div>
      </Col>
    </div>
  </>
);

export default User;